import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { MonitoringService } from '../../services/monitoring.service';
import { ImportItems } from '../../models';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
  selector: 'app-file-details-dialog',
  templateUrl: './file-details-dialog.component.html',
  styleUrls: ['./file-details-dialog.component.scss'],
})
export class FileDetailsDialogComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() fileId: number | null = null;
  @Input() fileName: string = '';
  @Output() visibleChange = new EventEmitter<boolean>();
  importItems: ImportItems | null = null;
  loading: boolean = false;
  pageSize: number = 200;
  first: number = 0;
  rowsPerPageOptions: number[] = [200, 500, 1000];

  private readonly monitoringService = inject(MonitoringService);

  // Getter pour générer dynamiquement le tableau pour le skeleton loading
  get loadingArray(): number[] {
    return Array(this.pageSize)
      .fill(0)
      .map((_, i) => i);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible && this.fileId) {
      this.resetPagination();
      this.loadImportItems({ first: 0, rows: this.pageSize });
    }
  }

  onHideDialog(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.resetData();
  }
  private resetPagination(): void {
    this.first = 0;
  }

  private resetData(): void {
    this.importItems = null;
    this.resetPagination();
  }
  loadImportItems(event: TableLazyLoadEvent): void {
    if (this.fileId === null) {
      console.warn('FileDetailsDialog - fileId is null, cannot load data');
      return;
    }

    this.loading = true;
    const first = event.first ?? 0;
    this.pageSize = event.rows ?? this.pageSize;

    // Calculer la page correctement pour l'API
    const page = Math.floor(first / this.pageSize) + 1;

    // Mettre à jour la propriété first pour la synchronisation avec PrimeNG
    this.first = first;

    this.monitoringService
      .getPaginatedImports(this.fileId, page, this.pageSize)
      .subscribe({
        next: (data: ImportItems) => {
          this.importItems = data;
          this.loading = false;
        },
        error: (error: unknown) => {
          console.error('FileDetailsDialog - Error while loading data:', error);
          this.loading = false;
        },
      });
  }
}
